import React, { Component } from "react";
import Header from "../header";
import LogoutPopUp from "./logoutPopUp";
import Spinner from "../Spinner/Spinner";
import { createGlobalStyle } from "styled-components";
import { Link } from "react-router-dom";

class profile extends Component {
  state = {
    loading: true,
    display: false,
    userInfo: {},
    changeename: false,
  };
  componentDidMount() {
    let data;
    data = JSON.parse(localStorage.getItem("splash"));
    this.setState({
      userInfo: data.customer_info,
      loading: false,
    });
  }

  render() {
    const logOutHandler = () => {
      this.setState({ display: true });
      window.scrollTo(0, 0);
    };
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <Header
              showSearchBar={true}
              title={"حساب کاربری"}
              isDarkTheme={true}
              backUrl={"/"}
            />
            <img
              src="/public/assets/img/mainPage/Ellipse.png"
              className="eclips"
              alt="eclips"
            />
            <main className="EnterPass ProfileCom">
              <div className="SpecificationsProfil">
                <div className="ProfilePicture">
                  <img
                    src="/public/assets/icons/profilePic.png"
                    alt="profailimage"
                  />
                </div>
                <div className="ProfileName">
                  <span>{this.state?.userInfo?.name}</span>
                  <Link to="/profile/changename">
                    <div>
                      <img
                        src="/public/assets/icons/profile/edit.svg"
                        alt="edit"
                      />
                    </div>
                  </Link>
                </div>
              </div>

              <Link to={"/profile/myOrders"} className="itemDetail">
                <div className="profileOrdersTab">
                  <div className="circleDark">
                    <img
                      src="public/assets/icons/profile/shoppingcart.svg"
                      alt="myOrders"
                    />
                  </div>
                  <span>سفارشات</span>
                </div>
              </Link>
              <div className="items">
                <Link to={"/profile/changeLocation"} className="itemDetail">
                  <div className="circleDark purpleCircle">
                    <i className="icon-marker" />
                  </div>
                  <div className="changeCity">
                    <span>تغییر شهر</span>
                    <span>{this.state?.userInfo?.city?.name}</span>
                  </div>
                </Link>
                <Link to={"/profile/Wallet"} className="itemDetail">
                  <div className="circleDark">
                    <img src="public/assets/icons/profile/wallet.svg" />
                  </div>
                  <span>کیف پول</span>
                </Link>
                <Link to={"/profile/chooseAddress"} className="itemDetail">
                  <div className="circleDark">
                    <img src="public/assets/icons/profile/minimap.svg" />
                  </div>
                  <span>آدرس های من</span>
                </Link>
                <Link to={"/profile/MyFavorite"} className="itemDetail">
                  <div className="circleDark">
                    <img src="public/assets/icons/profile/heart.svg" />
                  </div>
                  <span>علاقمندی ها</span>
                </Link>
                <Link to={"/profile/CommentDashboard"} className="itemDetail">
                  <div className="circleDark">
                    <img
                      src="public/assets/icons/profile/comment.svg"
                      alt="comments"
                    />
                  </div>
                  <span>دیدگاه ها</span>
                </Link>
                <Link to={"/profile/MyCars"} className="itemDetail">
                  <div className="circleDark">
                    <img src="public/assets/icons/profile/car.svg" />
                  </div>
                  <span>لیست خودروهای من</span>
                </Link>
                <Link to={"/profile/RecentVisit"} className="itemDetail">
                  <div className="circleDark">
                    <img
                      src="public/assets/icons/profile/menu.svg"
                      alt="lastvisit"
                    />
                  </div>
                  <span>بازدیدهای اخیر</span>
                </Link>
                <Link to={"/profile/ChangePass"} className="itemDetail">
                  <div className="circleDark">
                    <img
                      src="public/assets/icons/profile/lock.svg"
                      alt="changeePasword"
                    />
                  </div>
                  <span>تغییر رمز عبور</span>
                </Link>
                <Link to={"/profile/InviteFriend"} className="itemDetail">
                  <div className="circleDark">
                    <img
                      src="public/assets/icons/profile/friend.svg"
                      alt="friend"
                    />
                  </div>
                  <span>دعوت از دوستان</span>
                </Link>
                <Link to="/rules" className="itemDetail">
                  <div className="circleDark">
                    <img src="public/assets/icons/profile/warning.svg" />
                  </div>
                  <span>قوانین و شرایط</span>
                </Link>
                <Link to="/legalInfo" className="itemDetail">
                  <div className="circleDark">
                    <img src="/public/assets/icons/profile/edit.svg" />
                  </div>
                  <span>اطلاعات حقوقی</span>
                </Link>
                <Link to="/evaluation" className="itemDetail">
                  <div className="circleDark">
                    <img src="public/assets/icons/profile/tick.svg" />
                  </div>
                  <span>ارزیابی</span>
                </Link>
                <Link to="/showMore/Support" className="itemDetail">
                  <div className="circleDark">
                    <img
                      src="public/assets/icons/profile/headphone.svg"
                      alt="Support"
                    />
                  </div>
                  <span>پشتیبانی</span>
                </Link>
                <div className="itemDetail" onClick={() => logOutHandler()}>
                  <div className="circleDark">
                    <img
                      src="public/assets/icons/profile/power.svg"
                      alt="Logout"
                    />
                  </div>
                  <span>خروج از حساب کاربری</span>
                </div>
              </div>
              <LogoutPopUp
                displayPopup={this.state.display}
                hidePopup={() => this.setState({ display: false })}
              />
            </main>
          </>
        )}
      </>
    );
  }
}
export default profile;
